import { render, staticRenderFns } from "./table.vue?vue&type=template&id=4b48cc46&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"
import style0 from "./table.vue?vue&type=style&index=0&id=4b48cc46&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b48cc46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b48cc46')) {
      api.createRecord('4b48cc46', component.options)
    } else {
      api.reload('4b48cc46', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=4b48cc46&scoped=true", function () {
      api.rerender('4b48cc46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/components/physicalModel/table.vue"
export default component.exports